import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  getReferenceList,
  selectAddMember,
} from "../../../state/ducks/loyalty/index";
import EminevimLoading from "../shared/EminevimLoading";
import AppCustomSelect from "../shared/AppCustomSelect";

String.prototype.turkishtoEnglish = function () {
  return this.replaceAll("Ğ", "g")
    .replaceAll("Ü", "u")
    .replaceAll("Ş", "s")
    .replaceAll("I", "i")
    .replaceAll("İ", "i")
    .replaceAll("Ö", "o")
    .replaceAll("Ç", "c")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ş", "s")
    .replaceAll("ı", "i")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c");
};

class MyReferences extends Component {
  state = {
    searchFilter: "",
    pageSize: 10,
    currentPage: 1,
    sortField: "adi",
    sortDirection: "asc",
    isLoading: true,
    shouldAnimateCard: false,
  };

  componentDidMount() {
    this.props.getReferenceList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loyalty?.references !== this.props.loyalty?.references) {
      if (this.state.isLoading) {
        this.setState({ isLoading: false, shouldAnimateCard: true });
        window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
      }
    }
  }

  getFilteredReferences = () => {
    const references = this.props.loyalty?.references || [];
    const filter = (this.state.searchFilter || "").turkishtoEnglish().toLowerCase().trim();

    if (!filter) {
      return references;
    }

    return references.filter((item) => {
      return (
        item?.adi?.turkishtoEnglish().toLowerCase().includes(filter) ||
        item?.durum?.turkishtoEnglish().toLowerCase().includes(filter) ||
        item?.gecerlilikSuresi?.toString().turkishtoEnglish().toLowerCase().includes(filter)
      );
    });
  };

  getSortedReferences = () => {
    const { sortField, sortDirection } = this.state;
    const references = [...this.getFilteredReferences()];

    references.sort((a, b) => {
      const left = a?.[sortField];
      const right = b?.[sortField];

      if (sortField === "gecerlilikSuresi") {
        const leftNum = Number(left) || 0;
        const rightNum = Number(right) || 0;
        return sortDirection === "asc" ? leftNum - rightNum : rightNum - leftNum;
      }

      const leftText = (left || "").toString().turkishtoEnglish().toLowerCase();
      const rightText = (right || "").toString().turkishtoEnglish().toLowerCase();

      if (leftText < rightText) return sortDirection === "asc" ? -1 : 1;
      if (leftText > rightText) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    return references;
  };

  getPaginatedReferences = () => {
    const references = this.getSortedReferences();
    const { currentPage, pageSize } = this.state;
    const startIndex = (currentPage - 1) * pageSize;

    return references.slice(startIndex, startIndex + pageSize);
  };

  getTotalPages = () => {
    const totalItems = this.getSortedReferences().length;
    return Math.max(1, Math.ceil(totalItems / this.state.pageSize));
  };

  handleSearchFilterChange = (event) => {
    this.setState({ searchFilter: event.target.value, currentPage: 1 });
  };

  clearSearchFilter = () => {
    this.setState({ searchFilter: "", currentPage: 1 });
  };

  handlePageSizeChange = (event) => {
    this.setState({
      pageSize: Number(event.target.value),
      currentPage: 1,
    });
  };

  handleSort = (field) => {
    this.setState((prevState) => ({
      sortField: field,
      sortDirection:
        prevState.sortField === field && prevState.sortDirection === "asc" ? "desc" : "asc",
      currentPage: 1,
    }));
  };

  goToPage = (page) => {
    const totalPages = this.getTotalPages();
    const nextPage = Math.min(Math.max(page, 1), totalPages);
    this.setState({ currentPage: nextPage });
  };

  renderSortIcon = (field) => {
    const { sortField, sortDirection } = this.state;

    if (sortField !== field) {
      return <i className="t-icon-unfold_more t-myReferences-sortIcon" aria-hidden="true" />;
    }

    return (
      <i
        className={`t-icon-keyboard_arrow_${sortDirection === "asc" ? "up" : "down"} t-myReferences-sortIcon t-myReferences-sortIcon--active`}
        aria-hidden="true"
      />
    );
  };

  renderReferencesLoading = () => (
    <EminevimLoading subtext="Referans listeniz hazırlanıyor, lütfen bekleyiniz." />
  );

  renderToolbar = () => (
    <div className="t-myReferences-toolbar">
      <div className="t-memberInfo-filterInputWrap t-myReferences-searchWrap">
        <i className="t-icon-search" aria-hidden="true" />
        <input
          type="text"
          className="t-memberInfo-filterInput"
          placeholder="Referans ara..."
          value={this.state.searchFilter}
          onChange={this.handleSearchFilterChange}
        />
        {this.state.searchFilter && (
          <button
            type="button"
            className="t-memberInfo-filterClear"
            onClick={this.clearSearchFilter}
            aria-label="Aramayı temizle"
          >
            &times;
          </button>
        )}
      </div>

      <div className="t-myReferences-pageSize">
        <label htmlFor="referencePageSize" className="t-myReferences-pageSizeLabel">
          Sayfa
        </label>
        <div className="t-myReferences-pageSizeSelect">
          <AppCustomSelect
            id="referencePageSize"
            value={this.state.pageSize}
            options={[
              { value: "10", label: "10" },
              { value: "20", label: "20" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
            onChange={(nextValue) => this.handlePageSizeChange({ target: { value: nextValue } })}
          />
        </div>
      </div>
    </div>
  );

  renderDesktopTable = (references) => (
    <div className="t-myReferences-tableWrap">
      <table className="t-myReferences-table">
        <thead>
          <tr>
            <th scope="col">
              <button type="button" className="t-myReferences-sortButton" onClick={() => this.handleSort("adi")}>
                Adı Soyadı
                {this.renderSortIcon("adi")}
              </button>
            </th>
            <th scope="col">
              <button type="button" className="t-myReferences-sortButton" onClick={() => this.handleSort("durum")}>
                Durumu
                {this.renderSortIcon("durum")}
              </button>
            </th>
            <th scope="col">
              <button
                type="button"
                className="t-myReferences-sortButton"
                onClick={() => this.handleSort("gecerlilikSuresi")}
              >
                Geçerlilik Süresi
                {this.renderSortIcon("gecerlilikSuresi")}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {references.map((item, index) => (
            <tr key={`${item.adi}_${item.durum}_${index}`}>
              <td data-label="Adı Soyadı">{item.adi || "-"}</td>
              <td data-label="Durumu">{item.durum || "-"}</td>
              <td data-label="Geçerlilik Süresi">{item.gecerlilikSuresi ?? "-"} Gün</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  renderMobileCards = (references) => (
    <div className="t-myReferences-mobileList">
      {references.map((item, index) => (
        <article className="t-myReferences-mobileCard" key={`${item.adi}_${item.durum}_${index}`}>
          <div className="t-myReferences-mobileField">
            <span className="t-myReferences-mobileLabel">Adı Soyadı</span>
            <span className="t-myReferences-mobileValue">{item.adi || "-"}</span>
          </div>
          <div className="t-myReferences-mobileField">
            <span className="t-myReferences-mobileLabel">Durumu</span>
            <span className="t-myReferences-mobileValue">{item.durum || "-"}</span>
          </div>
          <div className="t-myReferences-mobileField">
            <span className="t-myReferences-mobileLabel">Geçerlilik Süresi</span>
            <span className="t-myReferences-mobileValue">{item.gecerlilikSuresi ?? "-"} Gün</span>
          </div>
        </article>
      ))}
    </div>
  );

  renderPagination = (totalItems) => {
    const { currentPage, pageSize } = this.state;
    const totalPages = this.getTotalPages();
    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(currentPage * pageSize, totalItems);

    return (
      <div className="t-myReferences-pagination">
        <span className="t-myReferences-paginationInfo">
          {startItem} ile {endItem} / {totalItems}
        </span>

        <div className="t-myReferences-paginationActions">
          <button
            type="button"
            className="t-myReferences-pageButton"
            onClick={() => this.goToPage(1)}
            disabled={currentPage === 1}
            aria-label="İlk sayfa"
          >
            <i className="t-icon-first" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="t-myReferences-pageButton"
            onClick={() => this.goToPage(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Önceki sayfa"
          >
            <i className="t-icon-arrow-left2" aria-hidden="true" />
          </button>
          <span className="t-myReferences-pageIndicator">
            Sayfa {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            className="t-myReferences-pageButton"
            onClick={() => this.goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Sonraki sayfa"
          >
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="t-myReferences-pageButton"
            onClick={() => this.goToPage(totalPages)}
            disabled={currentPage === totalPages}
            aria-label="Son sayfa"
          >
            <i className="t-icon-last" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { shouldAnimateCard, isLoading } = this.state;
    const sortedReferences = this.getSortedReferences();
    const paginatedReferences = this.getPaginatedReferences();
    const totalReferences = (this.props.loyalty?.references || []).length;

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Referanslarım</h1>
              <p className="t-memberInfo-pageSubtitle">
                Onaylı referanslarınızı görüntüleyin, arama yapın ve yeni referans ekleyin.
              </p>
            </div>

            {isLoading ? (
              this.renderReferencesLoading()
            ) : (
              <article
                className={`t-memberInfo-card t-memberDetail-header--orange${
                  shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                }`}
              >
                <div className="t-memberInfo-cardHeader">
                  <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                    <i className="t-icon-user-check" aria-hidden="true" />
                  </div>

                  <div className="t-memberInfo-cardHeaderContent">
                    <h2 className="t-memberInfo-cardTitle">Referanslarım</h2>
                    <div className="t-memberInfo-cardBadges">
                      <span className="t-memberDetail-headerBadge">
                        Toplam: {totalReferences}
                      </span>
                    </div>
                  </div>

                  <div className="t-memberInfo-cardActions">
                    <Link
                      to="/Home/SubmitReference"
                      className="t-memberInfo-btn t-memberInfo-btn--primary"
                    >
                      <span>Referans Ekle</span>
                      <i className="t-icon-arrow-right2" aria-hidden="true" />
                    </Link>
                  </div>
                </div>

                {this.renderToolbar()}

                {sortedReferences.length > 0 ? (
                  <>
                    <div className="t-myReferences-desktopOnly">
                      {this.renderDesktopTable(paginatedReferences)}
                    </div>
                    <div className="t-myReferences-mobileOnly">
                      {this.renderMobileCards(paginatedReferences)}
                    </div>

                    {this.renderPagination(sortedReferences.length)}

                    <div className="t-myReferences-summary">
                      Gösterilen: <strong>{sortedReferences.length}</strong>
                      {this.state.searchFilter ? ` / Toplam: ${totalReferences}` : ""}
                    </div>
                  </>
                ) : (
                  <div className="t-memberInfo-emptyFilter">
                    {this.state.searchFilter
                      ? "Arama kriterlerinize uygun referans bulunamadı."
                      : "Görüntülenecek referans bulunmuyor."}
                  </div>
                )}
              </article>
            )}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loyalty: selectAddMember(state),
});

const mapDispatchToProps = (dispatch) => ({
  getReferenceList: () => dispatch(getReferenceList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyReferences);
